import React from "react";
import { DeviceWidth, useDeviceWidthQuery } from "./MediaQuery";

export const Content: React.FC<{
  children?: React.ReactNode;
}> = (props) => {
  const deviceWidth = useDeviceWidthQuery();

  return (
    <div
      style={{
        width: {
          [DeviceWidth.mobile]: 300,
          [DeviceWidth.desktop]: 1180,
        }[deviceWidth],
        marginLeft: "auto",
        marginRight: "auto",
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      {props.children}
    </div>
  );
};
